module.exports = __webpack_public_path__ + "img/ec-logo.e82581af.png";